import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";

import analysisReducer from "./playbook-analysis-slice";
import userReducer from "./user-slice";
import fileReducer from "./file-slice";

const persistConfig = {
	key: "root",
	storage,
	whitelist: ["user"],
	serialize: true,
};

const persistedUserReducer = persistReducer(persistConfig, userReducer);

const store = configureStore({
	reducer: {
		files: fileReducer,
		analysis: analysisReducer,
		user: persistedUserReducer,
	},

	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		}),
});

const persistor = persistStore(store);

export { store, persistor };

export type RootState = ReturnType<typeof store.getState>;
